// extracted by mini-css-extract-plugin
export var postAd = "style-module--post-ad--d99e4";
export var postAd__content = "style-module--post-ad__content--4ee57";
export var postAd__image = "style-module--post-ad__image--bc817";
export var postAd__text = "style-module--post-ad__text--27298";
export var postAd__title = "style-module--post-ad__title--600d6";